import { ScreenView, IScreenViewConfig } from '@nolimitcity/slot-game/bin/core/screen/ScreenView';
import { GameResources } from '@nolimitcity/slot-game/bin/core/resource/GameResources';
import { TweenLite } from 'gsap';
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {FreespinsLeftIndicator} from "../../freespinsleft/FreespinsLeftIndicator";

export class BFScatterNudgeView extends ScreenView {
    protected initAnimations(): void {
        super.initAnimations();
        this._button.visible = false;
    }

    public showAddFreespin(position: [number, number]): void {
        const sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("freespinAdd1")[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(position[0], position[1]);
        sprite.scale.set(0.8, 0.8);
        // this._allNumbers.push(sprite);
        this._layer.addChild(sprite);
        EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.UPDATE_BIG_FS_COUNT));

        // Cannot abort while freespin.
        TweenLite.to(sprite, 0.3, { alpha: 0, delay: 0.3 });
        TweenLite.to(sprite, 0.7, {
            y: position[1] - 100,
            onComplete: () => {
                this._layer.removeChild(sprite);
                // ArrayHelper.removeFirstMatchElement(this._allNumbers, sprite);
            }
        });
    }

}